import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-short-about-block',
  templateUrl: './short-about-block.component.html',
  styleUrls: ['./short-about-block.component.scss']
})
export class ShortAboutBlockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
